export const styleswiper = {
  fondo: {
    position: "absolute", height: "100%", width: "100%",
    backgroundColor: 'black',
    opacity: 0.4
  },
  titulo: {
    textTransform: 'uppercase',
     fontSize: '1.0em',
  },
  subtitulo: {
    textColor: 'red',
     fontSize: '0.9em',
    fontWeight:"bold"
  },
  button: {
     width: '150px',
    fontSize: '1.2em'
  },
  slideimg: {
    height: "453px",
    width: "100%",
    position: "relative",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat", backgroundSize: "cover",
  },  
  slideimgcenter: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundPosition: "center",
    filter: 'blur(1.0rem)',
    backgroundRepeat: "no-repeat", backgroundSize: "cover",
  },
  slideimgdes: {
    height: "453px",
    width: "1000px",
    position: "absolute",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",   
  },
}
export const styleswipers = {
  fondo: {
    position: "absolute", height: "100%", width: "100%",
    backgroundColor: 'black',
    opacity: 0.4
  },
  titulo: { fontFamily: 'cursive,bold, fantasy ', fontSize: '1.8em' },
  subtitulo: { fontFamily: 'cursive,bold,fantasy ', fontSize: '1.2em' },
  button: { fontFamily: 'cursive,bold,fantasy ' },
  slideimg: {
    height: "453px",
    width: "100%",
    position: "relative",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat", backgroundSize: "contain",
  },
  slideimgcenter: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundPosition: "center",
    filter: 'blur(0.9rem)',
    backgroundRepeat: "no-repeat", backgroundSize: "cover",
  }

}
